module.exports = __webpack_public_path__ + "img/heykama-sm.d9aaf38d.png";